import React, { memo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './Menu.module.less';
import { useAliveController } from 'react-activation';
import { logPostInfo } from '../../../actions/log';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { clearTag } from '../../../actions/game';
import { refresh } from 'less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ base, tabs }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { dropScope, getCachingNodes, refresh } = useAliveController();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const handleClick = (source, path, tabcode) => {
    dispatch(
      logPostInfo({
        source: source || logInfoData.source,
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    dropScope(`game${tabcode}`);
    // refresh(`game${tabcode}`);
    if (tabcode === 'gameLibrary') {
      dispatch(clearTag());
    }
    const timer = setTimeout(() => {
      history.push(path);
      clearTimeout(timer);
    }, 100);
  };

  return (
    <div className={styles.menu}>
      <nav>
        {tabs.map(tab => (
          <div
            key={tab.code}
            className={`${styles.nav_item} ${
              pathname === base + '/' + tab.code ? styles.nav_active : ''
            }`}
            onClick={() => handleClick(tab.source, `${base}/${tab.code}`, tab.code)}
          >
            {tab.name}
          </div>
        ))}
      </nav>
    </div>
  );
});
